import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient, HttpHeaders, HttpBackend } from "@angular/common/http";
import { apiLinks } from '../core/api-links/api-links';
import { environment } from "../../environments/environment";
import { Observable, throwError } from "rxjs";
import { map, catchError, retry } from "rxjs/operators";
import axios from "axios";
import { AxiosInstance } from "axios";
import { CommonService } from 'src/app/providers/common.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private axiosClient: AxiosInstance;
  private errorHandler: ErrorHandler;

  public getAllMerchantUrl = `${environment.apiUrl}/merchants-dashboard`;
  private getAllTransactionUrl = `${environment.apiUrl}/transactions-dashboard`;
  private getTPNcountUrl = `${environment.apiUrl}/gettpncount-dashboard`;
  private getAllISOUrl = `${environment.apiUrl}/customersDBA`;
  private getAllCustomerUnderISOUrl = `${environment.apiUrl}/getCustomerUnderISO`;
  private getStoreIdUrl = `${environment.apiUrl}/storeid-dashboard`;
  private getOwnerMerchantIdUrl = `${environment.apiUrl}/merchantOwnerId-dashboard`;
  private getTPNandLabelUrl = `${environment.apiUrl}/tpnLabelData-dashboard`;
  private getNTTPNlistUrl = `${environment.apiUrl}/getNTTPNdetails`;
  private getMerchantInfoUrl = `${environment.apiUrl}/getMerchantInfo`;
  private getDashboardDataInfoUrl = `${environment.apiUrl}/getDashboardDataInfo`;
  private getIsoDashboardDataUrl = `${environment.apiUrl}/getIsoDashboardData`;
  private getMerchantDashboardDataInfoUrl = `${environment.apiUrl}/getMerchantDashboardDataInfo`;
  private getNewDashboardDataInfoUrl = `${environment.apiUrl}/getNewDashboardDataInfo`;
  private getNewDashboardDataInfoCombineUrl = `${environment.apiUrl}/getNewDashboardDataInfo_Combine`;
  private getNewIsoDashboardDataUrl = `${environment.apiUrl}/getNewIsoDashboardData`;
  private getNewMerchantDashboardDataUrl = `${environment.apiUrl}/getNewMerchantDashboardData`;

  constructor(private httpDruid: HttpClient, handler: HttpBackend, private commonService: CommonService) {
    // this.httpDruid = new HttpClient(handler);

    // The ApiClient wraps calls to the underlying Axios client.
    this.axiosClient = axios.create({
      timeout: 3000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: "no-cache",
      },
      withCredentials: false,
    });

  }

  // getDruidData(query: string) {
  //   return this.httpDruid.post(this.druidBaseURL, {
  //     query, "context": { "timeout": 8000 }
  //   },
  //     { withCredentials: false, headers: new HttpHeaders({ timeout: `${10000}`, 'Authorization': 'Basic ' + btoa(`${this.commonService.getAccountPersonalData("druidName")}:${this.commonService.getAccountPersonalData("druidKeyName")}`) }) }
  //   ).pipe(
  //     retry(2),
  //     map((res: any) => {
  //       return res;
  //     }),
  //     catchError(this.handleError)
  //   );
  // }

  getAllMerchants() {
    console.log('am here now.......getAllMerchants');
    return this.httpDruid.get(`${this.getAllMerchantUrl}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getStoreId() {
    console.log('am here now.........getStoreId');
    return this.httpDruid.get(`${this.getStoreIdUrl}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getTPNandLabel() {
    return this.httpDruid.get(`${this.getTPNandLabelUrl}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }  

  getAllISOs() {
    return this.httpDruid.post(`${this.getAllISOUrl}`,{}).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getOwnerMerchantId() {
    return this.httpDruid.get(`${this.getOwnerMerchantIdUrl}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getAllCustomerUnderISO(bodyData: string[]) {
    return this.httpDruid.post(this.getAllCustomerUnderISOUrl, {
      isoCustomerId: bodyData
    },
    ).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getAllTransactions(bodyData: string[]) {
    return this.httpDruid.post(this.getAllTransactionUrl, {
      merchantIds: bodyData
    },
    ).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getTPNcount(bodyData: string[]) {
    return this.httpDruid.post(this.getTPNcountUrl, {
      merchantIds: bodyData
    },
    ).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getNTTPNlist(bodyData: string[]) {
    return this.httpDruid.post(this.getNTTPNlistUrl, bodyData
    ).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getMerchantInfo(bodyData: string[]) {
    return this.httpDruid.post(this.getMerchantInfoUrl, {
      merchantIds: bodyData
    },
    ).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  handleError(error) {
    let errorMessage = {};
    console.log("Druid Error");
    // console.log("error", error);
    return null;
  }

  sortByPerYearPermonth(arr) {

    arr.sort((a, b) => {
      const date = new Date(a.perYear, a.perMonth)
      const date2 = new Date(b.perYear, b.perMonth)
      return date.getTime() - date2.getTime()
    })
  
    return arr
  } 

  getDashboardDataInfo(payLoad: any) {
    //console.log("payload******", payLoad);
    return this.httpDruid.post(this.getDashboardDataInfoUrl, payLoad,
      { headers: new HttpHeaders({ timeout: `${15000}` }) }
    ).pipe(
      retry(2),
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getIsoDashboardData(payLoad: any) {
    return this.httpDruid.post(this.getIsoDashboardDataUrl, payLoad,
      { headers: new HttpHeaders({ timeout: `${15000}` }) }
    ).pipe(
      retry(2),
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getMerchantDashboardDataInfo(payLoad: any) {
    return this.httpDruid.post(this.getMerchantDashboardDataInfoUrl, payLoad,
      { headers: new HttpHeaders({ timeout: `${15000}` }) }
    ).pipe(
      retry(2),
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getNewDashboardDataInfo(payLoad: any) {
    //console.log("payload******", payLoad);
    //+'?'+Math.random()
    return this.httpDruid.post(this.getNewDashboardDataInfoUrl, payLoad,
      { headers: new HttpHeaders({ timeout: `${15000}` }) }
    ).pipe(
      retry(2),
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getNewIsoDashboardData(payLoad: any) {
    return this.httpDruid.post(this.getNewIsoDashboardDataUrl, payLoad,
      { headers: new HttpHeaders({ timeout: `${15000}` }) }
    ).pipe(
      retry(2),
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }
  getNewMerchantDashboardData(payLoad: any) {
    return this.httpDruid.post(this.getNewMerchantDashboardDataUrl, payLoad,
      { headers: new HttpHeaders({ timeout: `${15000}` }) }
    ).pipe(
      retry(2),
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  getNewDashboardDataInfo_Combine(payLoad: any) {
    //console.log("payload******", payLoad);
    return this.httpDruid.post(this.getNewDashboardDataInfoCombineUrl, payLoad,
      { headers: new HttpHeaders({ timeout: `${15000}` }) }
    ).pipe(
      retry(2),
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  // Function to sum up total counts by deviceType
  mergeByDeviceType(arr) {
    return arr.reduce((acc, current) => {
      // Check if the deviceType already exists in the accumulator
      const existingDevice = acc.find(item => item.deviceType === current.deviceType);
      
      if (existingDevice) {
        // If exists, sum up the totalCount
        existingDevice.totalCount += current.totalCount;
      } else {
        // If not exists, add the current entry to the accumulator
        acc.push({ ...current });
      }
      
      return acc;
    }, []);
  };

}
